import { getCookie, removeCookie } from "./cookies";

const CSM_TOKEN = 'csm-token';
const COMM_CODE = 'communication_code';
const AUTH_FAIL = 'csm_authorization_filed';

export const getCsmToken = () => getCookie(CSM_TOKEN);
export const isCSMFailAuth = () => !!getCookie(AUTH_FAIL);
export const resetCSMFailCookie = () => {
 // eslint-disable-next-line
 if (globalThis?.document?.cookie) {
    removeCookie(AUTH_FAIL);
  }
}
export const getCsmCommunicationCode = () => getCookie(COMM_CODE);
export const isCsmMode = () => !!getCsmToken() || !!getCsmCommunicationCode();
export const isCsmAddProduct = () => !!getCsmToken();
export const isCsmCreateBasket = () => !!getCsmCommunicationCode();

export const resetMode = () => {
   // eslint-disable-next-line
  if (globalThis?.document?.cookie) {
    removeCookie(CSM_TOKEN);
    removeCookie(COMM_CODE);
  }
};
